import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

export default function CSS_ReferenceFunctions() {
  const functions = [
    {
      name: "acos()",
      desc: "Returns the inverse cosine of a number between -1 and 1",
    },
    {
      name: "asin()",
      desc: "Returns the inverse sine of a number between -1 and 1",
    },
    {
      name: "atan()",
      desc: "Returns the inverse tangent of a number between -∞ and ∞",
    },
    {
      name: "atan2()",
      desc: "Returns the inverse tangent of two values between -infinity and infinity",
    },
    {
      name: "attr()",
      desc: "Returns the value of an attribute of the selected element",
    },
    { name: "blur()", desc: "Applies a blur effect to an element" },
    {
      name: "brightness()",
      desc: "Adjusts the brightness of an element (brighter or darker)",
    },
    {
      name: "calc()",
      desc: "Allows you to perform calculations to determine CSS property values",
    },
    { name: "circle()", desc: "Defines a circle" },
    {
      name: "clamp()",
      desc: "Sets a value that adjusts between a min and max depending on viewport size",
    },
    {
      name: "color()",
      desc: "Allows a color to be specified in a particular color space",
    },
    {
      name: "color-mix()",
      desc: "Mixes two color values in a given color space, by a given amount",
    },
    { name: "conic-gradient()", desc: "Creates a conic gradient" },
    { name: "contrast()", desc: "Adjusts the contrast of an element" },
    { name: "cos()", desc: "Returns the cosine of an angle" },
    {
      name: "counter()",
      desc: "Returns the current value of the named counter",
    },
    {
      name: "counters()",
      desc: "Returns the current values of the named and nested counters",
    },
    {
      name: "cubic-bezier()",
      desc: "Defines a Cubic Bezier curve for animations",
    },
    { name: "drop-shadow()", desc: "Applies a drop shadow effect to an image" },
    { name: "ellipse()", desc: "Defines an ellipse" },
    {
      name: "exp()",
      desc: "Returns E raised to the power of the specified number",
    },
    { name: "fit-content()", desc: "Sizes an element based on its content" },
    { name: "grayscale()", desc: "Converts an image to grayscale" },
    {
      name: "hsl() / hsla()",
      desc: "Defines a color using the Hue-Saturation-Lightness model (HSL); optional alpha",
    },
    { name: "hue-rotate()", desc: "Applies a color rotation to an element" },
    {
      name: "hwb()",
      desc: "Defines a color using the Hue-Whiteness-Blackness model (HWB)",
    },
    {
      name: "hypot()",
      desc: "Returns the square root of the sum of squares of its parameters",
    },
    {
      name: "inset()",
      desc: "Defines a rectangle at the specified inset distances",
    },
    { name: "invert()", desc: "Inverts the colors of an image" },
    { name: "lab()", desc: "Specifies a color in the CIE L*a*b color space" },
    {
      name: "lch()",
      desc: "Specifies a color in the LCH (Lightness-Chroma-Hue) color space",
    },
    {
      name: "light-dark()",
      desc: "Returns a color depending on light or dark mode preference",
    },
    { name: "linear-gradient()", desc: "Creates a linear gradient" },
    {
      name: "log()",
      desc: "Returns the natural logarithm (base E) of a specified number",
    },
    {
      name: "matrix()",
      desc: "Defines a 2D transformation using a matrix of six values",
    },
    {
      name: "matrix3d()",
      desc: "Defines a 3D transformation using a 4x4 matrix",
    },
    {
      name: "max()",
      desc: "Uses the largest value from a list as the property value",
    },
    {
      name: "min()",
      desc: "Uses the smallest value from a list as the property value",
    },
    { name: "minmax()", desc: "Defines a size range (used in CSS grids)" },
    {
      name: "mod()",
      desc: "Returns the remainder after division of two numbers",
    },
    { name: "oklab()", desc: "Specifies a color in the OKLAB color space" },
    { name: "oklch()", desc: "Specifies a color in the OKLCH color space" },
    { name: "opacity()", desc: "Applies an opacity effect to an element" },
    {
      name: "perspective()",
      desc: "Defines a perspective view for a 3D transformed element",
    },
    { name: "polygon()", desc: "Defines a polygon shape" },
    {
      name: "pow()",
      desc: "Returns a number raised to the power of another number",
    },
    { name: "radial-gradient()", desc: "Creates a radial gradient" },
    {
      name: "ray()",
      desc: "Defines an offset-path line segment for an animated element",
    },
    {
      name: "rem()",
      desc: "Specifies a size relative to the root element font-size",
    },
    { name: "repeat()", desc: "Repeats a set of columns or rows in a grid" },
    { name: "repeating-conic-gradient()", desc: "Repeats a conic gradient" },
    { name: "repeating-linear-gradient()", desc: "Repeats a linear gradient" },
    { name: "repeating-radial-gradient()", desc: "Repeats a radial gradient" },
    {
      name: "rgb() / rgba()",
      desc: "Defines colors using the RGB model with optional alpha",
    },
    { name: "rotate()", desc: "Defines a 2D rotation of an element" },
    { name: "rotate3d()", desc: "Defines a 3D rotation of an element" },
    { name: "rotateX()", desc: "Defines a 3D rotation around the x-axis" },
    { name: "rotateY()", desc: "Defines a 3D rotation around the y-axis" },
    { name: "rotateZ()", desc: "Defines a 3D rotation around the z-axis" },
    {
      name: "round()",
      desc: "Rounds a number according to the specified rounding-strategy",
    },
    { name: "saturate()", desc: "Adjusts the color saturation of an element" },
    { name: "scale()", desc: "Defines a 2D scaling of an element" },
    { name: "scale3d()", desc: "Defines a 3D scaling of an element" },
    { name: "scaleX()", desc: "Scales an element horizontally" },
    { name: "scaleY()", desc: "Scales an element vertically" },
    { name: "sepia()", desc: "Converts an image to sepia" },
    { name: "sin()", desc: "Returns the sine of an angle" },
    { name: "skew()", desc: "Skews an element along the x- and y-axis" },
    { name: "skewX()", desc: "Skews an element along the x-axis" },
    { name: "skewY()", desc: "Skews an element along the y-axis" },
    { name: "sqrt()", desc: "Returns the square root of a number" },
    {
      name: "steps()",
      desc: "Creates a stepped timing function for animations",
    },
    { name: "tan()", desc: "Returns the tangent of a number" },
    {
      name: "translate()",
      desc: "Repositions an element along the x- and y-axis",
    },
    { name: "translateX()", desc: "Repositions an element along the x-axis" },
    { name: "translateY()", desc: "Repositions an element along the y-axis" },
    {
      name: "url()",
      desc: "Includes a file (like an image or font) in the stylesheet",
    },
    { name: "var()", desc: "Inserts the value of a custom property" },
  ];

  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1
        className="tutorial-title"
        style={{
          textAlign: "center",
          color: "#1e40af",
          marginBottom: "1.5rem",
          textShadow: "1px 1px 3px #93c5fd",
        }}
      >
        🎨 CSS Functions
      </h1>

      {/* Key Points */}
      <section
        style={{
          background: "linear-gradient(90deg, #dbeafe, #e0e7ff)",
          borderLeft: "6px solid #2563eb",
          padding: "1rem 1.5rem",
          borderRadius: "10px",
          marginBottom: "2rem",
        }}
      >
        <h2 style={{ color: "#1e3a8a" }}>🧠 Key Points</h2>
        <ul style={{ color: "#111827", lineHeight: "1.8" }}>
          <li>
            CSS functions allow **dynamic and calculated values** inside
            properties.
          </li>
          <li>They can manipulate **numbers, colors, angles, and strings**.</li>
          <li>
            Functions like <code>calc()</code>, <code>min()</code>,{" "}
            <code>max()</code>, and <code>clamp()</code> make layouts
            responsive.
          </li>
          <li>
            Color functions such as <code>rgb()</code>, <code>hsl()</code>, and{" "}
            <code>color-mix()</code> provide fine color control.
          </li>
          <li>
            You can even use **trigonometric and mathematical** functions for
            animations or transformations.
          </li>
        </ul>
      </section>

      {/* Function Table */}
      <div
        className="table-container"
        style={{
          overflowX: "auto",
          borderRadius: "12px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          marginBottom: "2rem",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            backgroundColor: "#f9fafb",
            color: "#111827",
            fontSize: "0.95rem",
          }}
        >
          <thead>
            <tr
              style={{
                background: "linear-gradient(90deg, #2563eb, #6366f1, #8b5cf6)",
                color: "#fff",
              }}
            >
              <th
                style={{
                  textAlign: "left",
                  padding: "12px 16px",
                  fontSize: "1.1rem",
                }}
              >
                Function
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "12px 16px",
                  fontSize: "1.1rem",
                }}
              >
                Description
              </th>
            </tr>
          </thead>
          <tbody>
            {functions.map((fn, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#eef2ff" : "#e0e7ff",
                  transition: "background 0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#c7d2fe")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor =
                    index % 2 === 0 ? "#eef2ff" : "#e0e7ff")
                }
              >
                <td
                  style={{
                    padding: "10px 16px",
                    color: "#2563eb",
                    fontWeight: "600",
                    fontFamily: "monospace",
                  }}
                >
                  {fn.name}
                </td>
                <td style={{ padding: "10px 16px" }}>{fn.desc}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Example Section */}
      <section
        style={{
          background: "linear-gradient(90deg, #e0f2fe, #dbeafe)",
          borderLeft: "6px solid #0284c7",
          padding: "1.5rem",
          borderRadius: "10px",
          marginBottom: "2rem",
        }}
      >
        <h2 style={{ color: "#075985" }}>
          💡 Example: Using calc() and clamp()
        </h2>
        <p>
          Here’s how <code>calc()</code> and <code>clamp()</code> can create a
          **responsive box** whose width adapts dynamically based on the
          viewport size.
        </p>

        <CodeCopyBlock
          code={`div {
  width: clamp(300px, 50%, 600px);
  height: calc(100vh - 100px);
  background: linear-gradient(90deg, #60a5fa, #a78bfa);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  border-radius: 12px;
}`}
          language="css"
        />

        <p style={{ marginTop: "1rem" }}>
          👉 The box never shrinks below <b>300px</b> and never grows beyond{" "}
          <b>600px</b>, no matter the screen size.
        </p>
      </section>

      {/* Next Step */}
      <section
        style={{
          background: "linear-gradient(90deg, #fef9c3, #fef08a)",
          borderLeft: "6px solid #ca8a04",
          padding: "1.5rem",
          borderRadius: "10px",
        }}
      >
        <h2 style={{ color: "#92400e" }}>🚀 Next Step</h2>
        <p style={{ color: "#78350f", lineHeight: "1.8" }}>
          Now that you’ve learned CSS functions, explore how they interact with
          **CSS variables**, **transitions**, and **custom properties**.
          <br />
          Next tutorial: <b>🎭 CSS Transform & Animation Functions</b> — learn
          how to use
          <code> translate() </code>, <code> rotate() </code>,{" "}
          <code> scale() </code>, and
          <code> matrix() </code> for advanced animations.
        </p>
      </section>
    </div>
  );
}
